import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Header from './components/rootHeader'
import Footer from './components/rootFooter'
import LoadingSpinner from './components/LoadingSpinner'
import styles from '../styles/module/RootLayout.module.scss'
import { useAuth } from '../contexts/AuthContext'

export default function Root() {
  const location = useLocation()
  const [userNetworkStatus, setUserNetworkStatus] = useState(null)
  const [loading, setLoading] = useState(false)

  const { user } = useAuth()
  const navigate = useNavigate()

  const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']
  let timer

  // this function sets the timer that logs out the user after 10 secs
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // clears any pending timer.
      resetTimer()
      // Listener clean up. Removes the existing event listener from the window
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer)
      })
      // logs out user
      logoutAction()
    }, 30 * 60000) // 10000ms = 10secs. You can change the time.
  }

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer)
  }

  // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
  const logoutAction = () => {
    console.log('Run')
    localStorage.clear()
    window.location.pathname = '/login'
  }

  useEffect(() => {
    // if (!user && (authRequired.find(element => element == location.pathname)) !== undefined) {
    //   navigate('/login')
    //   setLoading(false)
    // } else {
    //   setLoading(false)
    // }

    //setLoading(false);
    window.addEventListener(
      'online',
      (e) => {
        setUserNetworkStatus(true)
      },
      false
    )

    window.addEventListener(
      'offline',
      (e) => {
        setUserNetworkStatus(false)
      },
      false
    )
    // document.addEventListener("visibilitychange", onchange);

    document.addEventListener('visibilitychange', (event) => {
      if (document.visibilityState === 'visible') {
        console.log('Visivle')
      }
    })

    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer()
        handleLogoutTimer()
      })
    })
  }, [location.pathname])

  if (loading) return <h1>loading</h1>

  return (
    <>
      <Header userStatus={userNetworkStatus} />
      <main className={`ms-motion-fadeIn ${styles.main} ${location.pathname !== '/' ? 'main_' + location.pathname.slice(1, location.pathname.length) : 'main_home'}`}>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}
